import styled from 'styled-components';

export const GroupTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;

  b {
    font-weight: 700;
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border: 1px solid
      ${({ theme, $active }) =>
        $active ? theme.colors.primary.main : theme.colors.grey.white};
    border-radius: 8px;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      border-color: ${({ theme }) => theme.colors.primary.main};

      h4,
      svg {
        color: ${({ theme }) => theme.colors.primary.main};
      }
    }

    h4,
    svg {
      transition: all 0.3s ease;
      color: ${({ theme, $active }) =>
        $active ? theme.colors.primary.main : theme.colors.grey.white};
    }

    .badge {
      position: absolute;
      top: -5px;
      right: -5px;
      background: ${({ theme }) => theme.colors.primary.main};
      color: white;
      border-radius: 50%;
      width: 22px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
    }
  }

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    flex-direction: column;

    button {
      width: 100%;
      justify-content: center;
    }
  }
`;
